import { Heart, Utensils } from "lucide-react";
import { useT } from "@/lib/i18n";

export default function GivingBack() {
    const { t } = useT();
    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14" data-testid="giving-back">
            <div className="card-surface p-6 sm:p-10 relative overflow-hidden">
                <div className="absolute -right-8 -top-8 w-56 h-56 bg-emerald-500/10 blur-3xl rounded-full pointer-events-none" />
                <div className="relative grid lg:grid-cols-12 gap-6 items-center">
                    <div className="lg:col-span-8">
                        <span className="chip"><Heart className="w-3 h-3" /> {t("gb_chip")}</span>
                        <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-white">
                            {t("gb_title_a")} <span className="accent-gradient-text">{t("gb_title_b")}</span>
                        </h2>
                        <p className="mt-3 text-slate-300 leading-relaxed max-w-xl">
                            {t("gb_body")}
                        </p>
                    </div>
                    <div className="lg:col-span-4">
                        <div className="rounded-2xl p-5 border border-emerald-500/30 bg-emerald-500/5 text-center">
                            <Utensils className="w-7 h-7 text-emerald-300 mx-auto" />
                            <div className="mt-3 text-xs text-emerald-200/80 mono uppercase tracking-widest">
                                {t("gb_badge")}
                            </div>
                            <div className="mt-1 text-base font-semibold text-white">
                                {t("gb_badge_sub")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
